import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    player: {
        playerList: [],
        pending: false
    },
    total: 0,
    loading: false,
    searching: false,
    searchParams: {
        userID: "",
        roomNo: "",
        roomID: "",
        settleID: "",
        matchNo: "",
        roomType: "2",
        status: "4",
        gameIDs: "-1",
        start_date: undefined,
        end_date: undefined,
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("roomPriv")
    },
}

const roomPriv = (state = initialState, action) => {
    switch (action.type) {
        case 'ROOM_PRIV_LIST':
            return {
                ...state,
                ...action.payload
            }
        case 'ROOM_PRIV_PLAYER_LIST':
            return {
                ...state,
                player: {
                    ...state.player,
                    ...action.payload
                }
            }
        case 'ROOM_PRIV_LIST_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("roomPriv")
                },
            }
        default:
            return {...state};
    }
}

export default roomPriv
